import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';
import { servicePrintStyle } from './servicePrintStyle';

export default function ServiceAnnexPrint() {
  const { id, annexId } = useParams();
  const [annex, setAnnex] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setAnnex(null); setError('');
    authFetch(`/comenzi/interna/${id}/anexe/${annexId}`).then(data => { if (active) setAnnex(data); })
      .catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [id, annexId]);
  useEffect(() => {
    if (!annex) return;
    const timer = setTimeout(() => window.print(), 350);
    return () => clearTimeout(timer);
  }, [annex]);
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!annex) return <p>Se încarcă anexa...</p>;
  return <ServiceAnnexDocument annex={annex} />;
}

export function ServiceAnnexDocument({ annex }) {
  const d = annex.data, s = annex.snapshot, decision = annex.decision;
  const textBox = (title, value) => <div className="print-box"><b>{title}</b><div style={{ whiteSpace: 'pre-wrap', minHeight: '12mm' }}>{value || '—'}</div></div>;
  return <div className="print-a4 deviz-print">
    <style>{servicePrintStyle}</style>
    <div className="print-header border-bottom pb-3 mb-3">
      <div><h5>{s.firma}</h5><div>CUI: {s.cui}</div><div>{s.adresa}</div></div>
      <div className="text-end"><h4>ANEXA nr. {annex.number}</h4><b>Constatare și lucrări suplimentare</b>
        <div>la Comanda nr. {s.comanda} / {String(s.data_comanda || '').slice(0, 10)}</div></div>
    </div>
    <p><b>Client:</b> {s.client}<br /><b>Autovehicul:</b> {s.service_details?.marca_model || '—'} · {s.numar_auto || '—'}<br />
      <b>VIN:</b> {s.vin || '—'} · <b>Kilometraj:</b> {s.km || '—'}<br />
      <b>Data constatării:</b> {d.data_constatare} · <b>Întocmit de:</b> {d.creat_de}</p>
    <p>În urma operațiunilor de demontare / diagnosticare autorizate prin comanda inițială, au fost identificate defecțiunile suplimentare descrise mai jos.</p>
    {textBox('Problema nouă identificată', d.problema)}
    {textBox('Lucrări suplimentare propuse', d.lucrari)}
    {textBox('Piese și materiale necesare', d.piese)}
    <table className="print-table mb-3"><tbody>
      {[[d.valori_fara_tva ? "Total deja aprobat în comandă, fără TVA" : "Total deja aprobat în comandă, cu TVA", d.valoare_anterioara], [d.piese_cu_tva != null ? "Piese suplimentare cu TVA inclus" : "Piese suplimentare fără TVA", d.piese_cu_tva ?? d.piese_lei],
        [d.manopera_cu_tva != null ? "Manoperă suplimentară cu TVA inclus" : "Manoperă suplimentară fără TVA", d.manopera_cu_tva ?? d.manopera_lei], [d.piese_cu_tva != null ? "Din care TVA supliment (inclus în sumele de mai sus)" : "TVA supliment", d.tva_lei],
        [d.valori_fara_tva ? "Total adăugat în anexă, fără TVA" : "Total adăugat în anexă, cu TVA", d.supliment_total], [d.valori_fara_tva ? "Total inclusiv anexă, fără TVA" : "Total inclusiv anexă, cu TVA", d.total_nou]].map(([label, amount]) =>
        <tr key={label}><td>{label}</td><td className="text-end"><b>{Number(amount).toFixed(2)} lei</b></td></tr>)}
    </tbody></table>
    <p><b>Noul termen estimat de finalizare:</b> {d.termen}</p>
    {annex.status === 'anulat' ? <div className="print-box"><h5>ANEXĂ ANULATĂ — NU AUTORIZEAZĂ LUCRĂRI</h5>
      <p>Motiv: {decision?.motiv_anulare}</p><p>Consemnat de {decision?.inregistrat_de} la {decision?.inregistrat_la}</p></div> : <div className="print-box" style={{ breakInside: 'avoid' }}>
      <h6>Decizia clientului</h6>
      <p>{annex.status === 'acceptat' ? '☑' : '☐'} Accept integral lucrările suplimentare de mai sus.<br />
        {annex.status === 'refuzat' ? '☑' : '☐'} Nu accept lucrările suplimentare.</p>
      <p>Autorizez numai lucrările acceptate în această anexă, la costul suplimentar și termenul consemnate. Lucrările suplimentare nu se execută înainte de obținerea acordului meu scris.</p>
      <p>Client / reprezentant: {decision?.semnatar || '........................................................'}<br />
        Data și ora: {decision?.data_semnarii?.replace('T', ' ') || '........................................................'}</p>
      <div className="grid-2" style={{ marginTop: '12mm' }}><div>Semnătura clientului: ........................</div><div>Semnătura service: ........................</div></div>
      {decision && <div className="small mt-3"><b>{annex.status === 'acceptat' ? 'Aprobat' : 'Refuzat'} prin {({ semnatura: 'document semnat', sms: 'SMS', email: 'e-mail' })[decision.modalitate]} la {decision.data_semnarii?.replace('T', ' ')}</b>
        <div>Referință / arhivare: {decision.document_semnat}. Înregistrat de {decision.inregistrat_de}.</div>
        {decision.mesaj && <div style={{ whiteSpace: 'pre-wrap' }}>Mesaj client: {decision.mesaj}</div>}</div>}
      {!decision && <p className="small mt-3"><b>În așteptarea acordului scris al clientului.</b></p>}
    </div>}
    <div className="no-print mt-3"><button className="btn btn-primary" onClick={() => window.print()}>Print anexă</button></div>
  </div>;
}
